module.exports = __webpack_public_path__ + "static/img/bg-ar.73c287b1.png";